import store from '@/store/index'

export default {}

/**
 * Returns the full state object of the pool tracking module.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['events/findEventPoolsWidgetModule/get']
}

/**
 * Returns the sets of selected pools.
 *
 * @return Object
 */
export const selectedPoolSets = () => {
  return store.getters['events/findEventPoolsWidgetModule/eventPoolsSelectionSets']
}

/**
 * Returns pools that are selected for the specified set.
 *
 * @param set String
 *
 * @return Object
 */
export const selectedPools = (set) => {
  if (store.getters['events/findEventPoolsWidgetModule/eventPoolsSelectionSets'].hasOwnProperty(set)) {
    return store.getters['events/findEventPoolsWidgetModule/eventPoolsSelectionSets'][set]
  } else {
    return {}
  }
}

/**
 * Returns the first selected pool in the specified set or null if none is selected.
 *
 * @param set String
 *
 * @return Object|null
 */
export const selectedPool = (set) => {
  if (store.getters['events/findEventPoolsWidgetModule/eventPoolsSelectionSets'].hasOwnProperty(set)) {
    const pools = store.getters['events/findEventPoolsWidgetModule/eventPoolsSelectionSets'][set]
    const poolIds = Object.keys(pools)
    if (poolIds.length > 0) {
      return pools[poolIds[0]]
    } else {
      return null
    }
  } else {
    return null
  }
}

/**
 * Returns true if the specified pool is selected within the supplied set.
 *
 * @param set String
 * @param id Integer
 *
 * @return Boolean
 */
export const isSelected = (set, id) => {
  return selectedPools(set).hasOwnProperty(id)
}

/**
 * Returns either a pool object or null depending on whether
 * queries should be made by pool.
 *
 * @return Object|null
 */
export const getPool = () => {
  return store.getters['events/findEventPoolsWidgetModule/getPool']
}

/**
 * Query the event pools
 *
 * @return Promise
 */
export const query = (params) => {
  return store.dispatch('events/findEventPoolsWidgetModule/query', params)
}

/**
 * Query the event pools by client
 *
 * @return Promise
 */
export const queryByClient = (params) => {
  return store.dispatch('events/findEventPoolsWidgetModule/queryByClient', params)
}

/**
 * Add a map or array of object pools that have been selected within
 * the specified set.
 *
 * @param set String
 * @param pools Array|Map
 */
export const addSelectedPools = (set, pools) => {
  store.commit('events/findEventPoolsWidgetModule/addSelectedPools', { set, pools })
}

/**
 * Set a client id for when using the queryByClient action.
 *
 * @param clientId int
 */
export const setClientId = (clientId) => {
  store.commit('events/findEventPoolsWidgetModule/setClientId', clientId)
}

/**
 * Set a single selected pool, all other selected pools
 * in the set will be cleared.
 *
 * @param set String
 * @param pool Object
 */
export const setSelectedPool = (set, pool) => {
  store.commit('events/findEventPoolsWidgetModule/setSelectedPool', { set, pool })
}

/**
 * Removes an array of pools from the set's list of selected pools.
 * The array must consist of the id's of the pools that are no
 * longer selected.
 *
 * @param set String
 * @param pools Array
 */
export const removeSelectedPools = (set, pools) => {
  store.commit('events/findEventPoolsWidgetModule/removeSelectedPools', { set, pools })
}

/**
 * Clears all selected pools within a specified set.
 */
export const clearSelectedPools = (set) => {
  store.commit('events/findEventPoolsWidgetModule/clearSelectedPools', set)
}

/**
 * Clears all selected pools.
 */
export const clearAllSelectedPools = () => {
  store.commit('events/findEventPoolsWidgetModule/clearAllSelectedPools')
}

/**
 * Returns the selected pool count for the specified set.
 *
 * @param set String
 *
 * @return Integer
 */
export const selectedPoolCount = (set) => {
  return Object.keys(selectedPools(set)).length
}

/**
 * Clears all pools from being tracked.
 */
export const purge = () => {
  store.commit('events/findEventPoolsWidgetModule/purge')
}

/**
 * Sets the pool for which the pools should be queried.
 *
 * @param pool Object|null
 */
export const setPool = (pool) => {
  store.commit('events/findEventPoolsWidgetModule/setPool', pool)
}

/**
 * Sets the client for which the pools should be queried.
 *
 * @param client Object|null
 */
export const setClient = (client) => {
  store.commit('events/findEventPoolsWidgetModule/setClient', client)
}

/**
 * Return an array of integers of the selected pools.
 *
 * @param set String
 * @returns [int]
 */
export const getSelectedPoolIds = (set) => {
  if (store.getters['events/findEventPoolsWidgetModule/eventPoolsSelectionSets'].hasOwnProperty(set)) {
    const units = store.getters['events/findEventPoolsWidgetModule/eventPoolsSelectionSets'][set]
    return Object.keys(units).map(key => parseInt(key))
  } else {
    return []
  }
}

/**
 * Returns pools that are selected for the specified set as an array
 *
 * @param set String
 *
 * @return Array
 */
export const selectedPoolsAsArray = (set) => {
  if (store.getters['events/findEventPoolsWidgetModule/eventPoolsSelectionSets'].hasOwnProperty(set)) {
    const pools = store.getters['events/findEventPoolsWidgetModule/eventPoolsSelectionSets'][set]
    const poolIds = Object.keys(pools)
    let results = []
    poolIds.forEach(poolId => {
      results.push(pools[poolId])
    })
    return results
  } else {
    return []
  }
}



// WEBPACK FOOTER //
// ./src/store/events/pools/findEventPoolsWidget.helpers.js